import { createFileRoute } from '@tanstack/react-router'
import AdminTestPage from '@/components/pages/Admin/AdminTestPage/AdminTestPage'

export const Route = createFileRoute('/$workspaceName/$environment/admin/test')({
  component: AdminTestRoute,
})

function AdminTestRoute() {
  return <AdminTestPage />
}
